const TAB = {
  BASIC: 'BASIC',
  ROOM_PRICE: 'ROOM_PRICE',
  AMENITIES_SERVICES: 'AMENITIES_SERVICES',
  ADD_IMAGES: 'ADD_IMAGES',
  POLICY: 'POLICY',
  PAYMENT: 'PAYMENT',
  FINAL_STEP: 'FINAL_STEP',
};

export default TAB;
